// src/lib/core/router/entity-loader.ts
function entityLoader(_queryClient) {
  return async ({ params }) => {
    const entityId = localStorage.getItem("entityId");
    const { entityId: entityIdRouter = "" } = params;
    if (entityId !== entityIdRouter) {
      localStorage.setItem("entityId", entityIdRouter);
    }
    return null;
  };
}

// src/lib/core/router/root-loader.ts
import { redirect } from "react-router-dom";
async function rootLoader() {
  const entityId = localStorage.getItem("entityId");
  if (!entityId) {
    throw new Response("entityId not found", { status: 404 });
  }
  return redirect(`/${entityId}`);
}

// src/lib/hooks/use-entity.ts
import { useParams } from "react-router-dom";
function useEntity() {
  const { entityId } = useParams();
  if (!entityId) {
    throw new Error(
      "No entityId found for current route. That probably means you try to access to entityId from path which is not scoped by entityId..."
    );
  }
  return { entityId };
}

// src/lib/utils/constants.ts
var ENTITY_ID_PREFIX = ":entityId";
export {
  ENTITY_ID_PREFIX,
  entityLoader,
  rootLoader,
  useEntity
};
